import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Cooperation from '../components/sections/Cooperation';
import Contact from '../components/sections/Contact';

const Home = () => {
  return (
    <main className="bg-zinc-950">
      <Hero />
      <About />
      <Services />
      <Cooperation />
      <Contact />
    </main>
  );
};

export default Home;